import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App.js'
import { AuthProvider } from './auth/AuthContext.js'

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)

/**
 * 註冊 Service Worker。
 *
 * 它存在的理由只有兩個：讓手機的「安裝」按鈕出得來（Chrome 要求要有帶 fetch
 * 處理的 Service Worker 才算可安裝），以及斷線時給一張看得懂的說明頁。
 * **它不快取任何 API 回應**——理由寫在 public/sw.js 的開頭。
 *
 * 開發時（vite dev server）不註冊：Service Worker 的快取會蓋掉 HMR，
 * 改了程式碼卻看到舊畫面是最浪費時間的一種錯誤。
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').then((reg) => {
      // 有新版本就直接換掉。追溯系統不該讓人拿舊版畫面過帳，
      // 所以這裡不做「要不要更新？」的詢問——下次開就是新的。
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing
        if (!installing) return
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            void reg.update()
          }
        })
      })
    }).catch((err: unknown) => {
      /*
       * 註冊失敗不影響作業（App 本來就要連著網路），但**一定要講出來**。
       *
       * 最常見的原因是憑證不受信任：廠內用自簽憑證時，瀏覽器會讓使用者按
       * 「繼續前往」把網頁打開，卻**拒絕在這種頁面上註冊 Service Worker**。
       * 而沒有 Service Worker 就不符合可安裝條件 —— 手機上「加到主畫面」
       * 只會建捷徑，不會出現「安裝應用程式」，畫面也不會全螢幕。
       *
       * 這個錯誤原本是被靜默吞掉的，所以症狀（裝不起來）和原因（憑證）
       * 中間完全沒有線索。/pwa-check.html 會把這件事講清楚。
       */
      console.warn(
        '[PV Regen] Service Worker 註冊失敗，因此無法安裝成主畫面 App。\n' +
          '最常見的原因是這台裝置不信任廠內的憑證。\n' +
          '請打開 /pwa-check.html 看診斷結果與處理步驟。\n',
        err,
      )
    })
  })
}
